<!--
使用例

<BreadCrumbs v-model="currentGroupId" @click_breadCrumbs="selectedGroupChange" />

v-model
  デバイスグループID
  指定されたデバイスグループIDまでのパンくずを表示します
@click_breadCrumbs
  パンくずのグループがクリックされたときに発火するメソッドを指定
  クリックしたグループ権限情報(userDeviceGroupAuthorities)を渡します
  パンくずを動的に変更したいばあいはgroup.device_group_id で v-modelの変数を更新してください。
  
-->
<template>
  <v-breadcrumbs :items="breadCrumb" large>
    <template v-slot:divider>
      <v-icon>mdi-play</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item @click="selectedGroupChange(item)" href="#" :disabled="item.disabled">
        <div v-if="item.isDevice">
          {{ item[`device_name_locale${localeId}`] }}
        </div>
        <div v-else>
          {{ item[`device_group_name_locale${localeId}`] }}
        </div>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  export default {
    name: 'BreadCrumbs',
    components: {},
    data: () => ({
      currentGroup: null,
    }),
    computed: {
      ...mapGetters('groupAuthorities', ['getBreadCrumbs']),
      ...mapGetters('groupAuthorities', ['getDeviceByModelIdSerialNo']),
      breadCrumb() {
        const groupId = this.$props.value;
        const tmp = this.getBreadCrumbs(groupId);

        // modelIdとSerialNoが設定されている場合はデバイスを取得する
        if (this.$props.modelId && this.$props.serialNo) {
          const device = this.getDeviceByModelIdSerialNo(this.$props.modelId, this.$props.serialNo);

          if (device) {
            console.dir(device);
            device.isDevice = true;
            tmp.push(device);
          }
        }

        if (tmp.length > 0) {
          for (const item of tmp) {
            item.disabled = false;
          }
          if (this.$props.lastItemDisabled) {
            tmp[tmp.length - 1].disabled = true;
          }
        }
        return tmp;
      },
      localeId() {
        switch (this.$i18n.locale) {
          case 'en':
            return 1;
          case 'ja':
            return 2;
          case 'zh':
            return 3;
        }
        return 2;
      },
    },
    props: {
      value: undefined,
      modelId: undefined,
      serialNo: undefined,
      lastItemDisabled: {
        type: Boolean,
      },
    },
    created() {
      this.init();
    },
    mounted() {},
    methods: {
      ...mapActions('groupAuthorities', ['init']),
      selectedGroupChange(group) {
        if (group.isDevice) {
          this.$emit('click_breadCrumbsDevice', group);
        } else {
          this.$emit('click_breadCrumbs', group);
        }
      },
    },
  };
</script>
